import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/** Format date as "23 Jan 2026" */
export function formatSegmentDate(isoDate: string): string {
	const d = new Date(isoDate + "T12:00:00");
	return d.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

/** e.g. "2 min ago", "1 hour ago", "3 days ago" */
export function formatRelativeTime(iso: string): string {
	const d = new Date(iso);
	const now = Date.now();
	const s = Math.round((now - d.getTime()) / 1000);
	if (s < 60) return "just now";
	if (s < 3600) return `${Math.floor(s / 60)} min ago`;
	if (s < 86400) return `${Math.floor(s / 3600)} hr ago`;
	if (s < 2592000) return `${Math.floor(s / 86400)} days ago`;
	return d.toLocaleDateString();
}

export function getFaviconUrl(website: string): string {
	const url = new URL(
		"https://op.paulgeorge.dev/api/misc/favicon?url=" +
			encodeURIComponent(website),
	);
	return url.toString();
}
